import React from "react";
import { useQuery } from "@apollo/client";
import { COLLECTIONS_QUERY } from "../graphql/collections";
import { Box, Container, Grid, Typography, ButtonBase } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { buildImageUrl } from "../config";

export default function CollectionsIndexPage() {
  const { data, loading } = useQuery(COLLECTIONS_QUERY, {
    fetchPolicy: "cache-and-network",
  });
  const navigate = useNavigate();

  const list = data?.collections ?? [];

  return (
    <Box sx={{ py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontFamily: `"Bodoni Moda", serif`,
            fontWeight: 800,
            fontSize: { xs: 28, md: 42 },
          }}
        >
          Collections
        </Typography>
        <Typography sx={{ mt: 1, color: "text.secondary", maxWidth: 720 }}>
          Explore curated stories and signature pieces.
        </Typography>

        <Box sx={{ mt: 4 }}>
          {loading && <Typography color="text.secondary">Loading…</Typography>}

          <Grid container spacing={3}>
            {list.map((c: any) => {
              const img = c.images?.[0] ? buildImageUrl(c.images[0]) : "";
              return (
                <Grid key={c.id} item xs={12} sm={6} md={4}>
                  <ButtonBase
                    onClick={() => navigate(`/collections/${c.slug}`)}
                    sx={{
                      width: "100%",
                      display: "block",
                      borderRadius: 0,
                      overflow: "hidden",
                      border: "1px solid rgba(0,0,0,0.08)",
                    }}
                  >
                    <Box sx={{ height: 220, bgcolor: "#fafafa" }}>
                      {img ? (
                        <Box
                          component="img"
                          loading="lazy"
                          decoding="async"
                          src={img}
                          alt={c.name}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            height: "100%",
                            display: "grid",
                            placeItems: "center",
                          }}
                        >
                          <Typography color="text.secondary">
                            No image
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    <Box sx={{ p: 2.2, textAlign: "left" }}>
                      <Typography sx={{ fontWeight: 900, fontSize: 16 }}>
                        {c.name}
                      </Typography>
                      {c.description && (
                        <Typography
                          sx={{
                            mt: 0.8,
                            color: "text.secondary",
                            fontSize: 13,
                          }}
                        >
                          {c.description}
                        </Typography>
                      )}
                    </Box>
                  </ButtonBase>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
